import "./style.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import InnerNavigation from "@components/InnerNavigation";
import { useEffect } from "react";
import PagesHeader from "@components/PagesHeader";
import { EasterEgg } from "@pages/EasterEggPage";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "@api/consumer";
import { useQuery } from "@tanstack/react-query";

const navItems = [
  {
    name: "Deine Daten",
    link: "/profil/user-data",
    redirect: "",
  },
  {
    name: "Zustimmung",
    link: "/profil/consents",
    redirect: "",
  },
  {
    name: "Punkte und Status",
    link: "/profil/points",
    redirect: "",
  },
  {
    name: "Menu Skins",
    link: "/profil/menu-skins",
    redirect: "",
  },
  {
    name: "Deine Gutscheine",
    link: "/coupons/received",
    redirect: "",
  },
];

export default function Profile() {
  const navigate = useNavigate();
  const location = useLocation();

  const redirectToTwojeDane = () => {
    if (location.pathname === "/profil") {
      navigate("/profil/user-data");
    }
  };

  useEffect(() => {
    redirectToTwojeDane();
  }, [location.pathname]);

  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const filteredNavItems = Object.values(data?.skin).some(e => !!e)
    ? navItems
    : navItems.filter((item) => item.link !== "/profil/menu-skins");

  return (
    <section className="profile-page">
      <PagesHeader>
        <strong>Profil</strong>
      </PagesHeader>
      {/* <EasterEgg ident={"halloween2025_6"} direction="left" /> */}
      <div className="profile-wrapper">
        <InnerNavigation navItems={filteredNavItems} />
        <div className="outlet-wrapper">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
